<template>
  <component
    :is="layout"
    :channels="$section.products"
    :categories="availableCategories"
    :opts="opts"
    class="epg-grid-view--full"
  ></component>
</template>
<script>
  import { epgSectionMixin } from '../mixins';

  export default {
    mixins: [
      epgSectionMixin,
    ],
    data() {
      return {
        opts: {
          showScrollableHeader: true,
          showReturnToNow: true,
        },
      };
    },
  };
</script>
